import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const ratioFamilyPackageEntity: Entity = {
  model: model,
  repository: repository,
}

export default ratioFamilyPackageEntity
